import React from "react";
import "./PageLoader.css";

interface PageLoaderProps {
  message?: string;
  /** full = centered block (default), inline = compact row for tables */
  variant?: "full" | "inline" | "overlay";
}

const PageLoader: React.FC<PageLoaderProps> = ({
  message = "Loading...",
  variant = "full",
}) => (
  <div
    className={`page-loader page-loader--${variant}`}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="page-loader-spinner" aria-hidden>
      <span className="page-loader-ring" />
      <span className="page-loader-ring page-loader-ring--inner" />
    </div>
    {message && <p className="page-loader-message">{message}</p>}
  </div>
);

export default PageLoader;
